"use client";

import React, { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { useRouter } from "@bprogress/next/app";
import { locales, type Locale, defaultLocale } from "@/i18n";
import * as S from "./styles";

//Images
import USA from "@/assets/images/estados-unidos-da-america.png";
import BR from "@/assets/images/bandeira-do-brasil.png";
import PT from "@/assets/images/portugal.png";
import { StaticImageData } from "next/image";

const LanguageSwitcher = () => {
  const router = useRouter();
  const pathname = usePathname();
  const [currentLanguage, setCurrentLanguage] = useState<Locale>(defaultLocale);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const storedLang = localStorage.getItem("lang") as Locale | null;
    const langFromUrl = pathname.split("/")[1] as Locale | undefined;
    const language =
      storedLang && locales.includes(storedLang)
        ? storedLang
        : langFromUrl && locales.includes(langFromUrl)
          ? langFromUrl
          : defaultLocale;
    setCurrentLanguage(language);
  }, [pathname]);

  const handleLanguageChange = (lang: Locale) => {
    // Remove o locale atual do pathname e adiciona o novo
    // A regex captura todos os locales: pt-BR, pt-PT, en-US
    const localePattern = new RegExp(`^/(${locales.join("|")})(/|$)`);
    const pathWithoutLocale = pathname.replace(localePattern, "/");
    // Garante que não tenha dupla barra
    const cleanPath = pathWithoutLocale === "/" ? "" : pathWithoutLocale;
    const newPath = `/${lang}${cleanPath}`;

    localStorage.setItem("lang", lang);
    setCurrentLanguage(lang);
    router.push(newPath);
    setDropdownOpen(false);
  };

  const languageOptions: {
    value: Locale;
    label: string;
    icon: StaticImageData;
  }[] = [
    { value: "pt-BR", label: "Portugês", icon: BR },
    { value: "pt-PT", label: "Portugês de Portugal", icon: PT },
    { value: "en-US", label: "Inglês", icon: USA },
  ];

  return (
    <S.Div>
      <S.DropdownHeader onClick={() => setDropdownOpen(!dropdownOpen)}>
        <S.ImageFlag
          src={
            currentLanguage === "pt-BR"
              ? BR
              : currentLanguage === "pt-PT"
                ? PT
                : USA
          }
        />
        <S.IconArrow name="chevronDown" />
      </S.DropdownHeader>
      {dropdownOpen && (
        <S.DropdownList>
          {languageOptions.map((option) => (
            <S.DropdownItem
              key={option.value}
              onClick={() => handleLanguageChange(option.value)}
            >
              <S.ImageFlag src={option.icon} /> <S.Text>{option.label}</S.Text>
            </S.DropdownItem>
          ))}
        </S.DropdownList>
      )}
    </S.Div>
  );
};

export default LanguageSwitcher;
